import React from "react";
import { AuditLog, AuditLogChangeType } from "@common/types/auditLog";
import {
    isFieldReviewMeta,
    getTransactionReviewFieldLabel,
} from "@common/types/transactionFieldReview";
import { pluralize } from "@common/helpers/string";

interface Props {
    log: AuditLog;
}

export const TransactionLogFieldReviewContent: React.FC<Props> = ({ log }) => {
    const meta = isFieldReviewMeta(log.metadata) ? log.metadata : null;

    // Fall back to diff if metadata not present (older logs)
    const isCreate = log.changeType === AuditLogChangeType.CREATE;
    const rawField =
        meta?.reviewedField ??
        (isCreate
            ? log.diff.find((d) => d.field === "reviewedField")?.after?.value
            : log.diff.find((d) => d.field === "reviewedField")?.before?.value);

    const count = meta?.count ?? 1;
    const indirect = meta?.indirect ?? false;
    const memberCount = meta?.memberCount;

    const fieldBase = (() => {
        if (typeof rawField !== "string") {
            return "field";
        }
        return getTransactionReviewFieldLabel(rawField);
    })();
    const fieldText = pluralize(fieldBase, count);

    const memberNoun =
        memberCount != null ? pluralize("member", memberCount) : "";
    const membersText =
        indirect && memberCount != null && memberCount > 0
            ? ` for ${memberCount} ${memberNoun}`
            : "";

    return (
        <>
            Updated reviewed status for{" "}
            <strong>
                {count} {fieldText}
            </strong>
            {membersText}
        </>
    );
};
